import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.storm.image.restore;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
	additionalSagas,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORM_IMAGE_RESTORE',
	method: 'POST',
	url: '/storm/image/restore.json',
});

const selectors = {
	...defaultSelectors,
};

export {
	actions,
	reducer,
	sagas,
	selectors,
	additionalSagas as imageRestoreAdditionalSagas,
};
